var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(
      _vm._.get(
        this.$store.state.current_content,
        'secondary.LayoutHeadBannerWithoutLinks.conf.enabled'
      ) == 1
    )?_c('LayoutHeadBannerWithoutLinks',{attrs:{"itemData":_vm._.get(
        this.$store.state.current_content,
        'secondary.LayoutHeadBannerWithoutLinks.data'
      )}}):_vm._e(),_c('Breadcrumb'),_c('div',{staticClass:"container layout-outer flex-box"},[_c('div',{staticClass:"layout-left"},[(
          _vm._.get(
            this.$store.state.current_content,
            'primary.0.content.tabs.0.content'
          )
        )?_c('div',{staticClass:"text mt-21",domProps:{"innerHTML":_vm._s(
          _vm._.get(
            this.$store.state.current_content,
            'primary.0.content.tabs.0.content'
          )
        )}}):_vm._e(),(_vm._.get(this.$store.state.current_content, 'primary.0.smarttabs'))?_c('DownloadList',{attrs:{"itemData":_vm._.get(this.$store.state.current_content, 'primary.0.smarttabs')}}):_vm._e()],1),_c('div',{staticClass:"layout-right small"},[_c('h3',{staticClass:"transfer-title font-21 noto-semibold"},[_vm._v(" Other Money Transfers ")]),_c('div',{staticClass:"right-column",on:{"scroll":_vm.onScroll}},[_c('highlightsBox'),_c('highlightsBox'),_c('highlightsBox'),_c('highlightsBox'),_c('highlightsBox')],1)])]),(
      _vm._.get(
        this.$store.state.current_content,
        'secondary.AboutLinkBanner.conf.enabled'
      ) == 1
    )?_c('AboutLinkBanner',{attrs:{"itemData":_vm._.get(
        this.$store.state.current_content,
        'secondary.AboutLinkBanner.data'
      )}}):_vm._e(),(
      _vm._.get(
        this.$store.state.current_content,
        'secondary.NewsBlock.conf.enabled'
      ) == 1
    )?_c('NewsBlock',{attrs:{"itemData":_vm._.get(this.$store.state.current_content, 'secondary.NewsBlock.data')}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }